// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : added commend lines for response anda array
// MODIFIED DATE : 31-07-2025

/* eslint-disable import/no-anonymous-default-export */

import RoleActionTypes from './role.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// ADD ROLE DETAILS RESPONSE
	addRoleDetailsResponse: null,

	// UPDATE ROLE DETAILS RESPONSE
	updateRoleDetailsResponse: null,

	// GET ROLE LIST RESPONSE AND ARRAY
	getRoleListResponse: null,
	getRoleListArr: [],

	// FETCH ROLE DETAILS RESPONSE AND ARRAY
	fetchRoleDetailsResponse: null,
	fetchRoleDetailsArr: [],

	// DELETE ROLE DETAILS RESPONSE
	deleteRoleDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD ROLE DETAILS START *********************** */
		case RoleActionTypes.ADD_ROLE_DETAILS_SUCCESS:
			return { ...state, addRoleDetailsResponse: action.payload };

		case RoleActionTypes.ADD_ROLE_DETAILS_FAILURE:
			return { ...state, addRoleDetailsResponse: action.payload };

		case RoleActionTypes.ADD_ROLE_DETAILS_RESPONSE_CHANGED:
			return { ...state, addRoleDetailsResponse: null };
		/** ***************** ADD ROLE DETAILS END *********************** */

		/** ***************** UPDATE ROLE DETAILS START *********************** */
		case RoleActionTypes.UPDATE_ROLE_DETAILS_SUCCESS:
			return { ...state, updateRoleDetailsResponse: action.payload };

		case RoleActionTypes.UPDATE_ROLE_DETAILS_FAILURE:
			return { ...state, updateRoleDetailsResponse: action.payload };

		case RoleActionTypes.UPDATE_ROLE_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateRoleDetailsResponse: null };
		/** ***************** UPDATE ROLE DETAILS END *********************** */

		/** ***************** GET ROLE DETAILS START *********************** */
		case RoleActionTypes.GET_ROLE_LIST_SUCCESS:
			return {
				...state,
				getRoleListResponse: action.payload,
				getRoleListArr: docodeHexResponse(action.payload, 'GetRoleListKey'),
			};

		case RoleActionTypes.GET_ROLE_LIST_FAILURE:
			return { ...state, getRoleListResponse: action.payload };

		case RoleActionTypes.GET_ROLE_LIST_RESPONSE_CHANGED:
			return { ...state, getRoleListResponse: null };
		/** ***************** GET ROLE DETAILS END *********************** */

		/** ***************** FETCH ROLE DETAILS START *********************** */
		case RoleActionTypes.FETCH_ROLE_DETAILS_SUCCESS:
			return {
				...state,
				fetchRoleDetailsResponse: action.payload,
				fetchRoleDetailsArr: docodeHexResponse(action.payload, 'FetchRoleDetailsKey'),
			};

		case RoleActionTypes.FETCH_ROLE_DETAILS_FAILURE:
			return { ...state, fetchRoleDetailsResponse: action.payload };

		case RoleActionTypes.FETCH_ROLE_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchRoleDetailsResponse: null, fetchRoleDetailsArr: [] };
		/** ***************** FETCH ROLE DETAILS END *********************** */

		/** ***************** DELETE ROLE DETAILS START *********************** */
		case RoleActionTypes.DELETE_ROLE_DETAILS_SUCCESS:
			return { ...state, deleteRoleDetailsResponse: action.payload };

		case RoleActionTypes.DELETE_ROLE_DETAILS_FAILURE:
			return { ...state, deleteRoleDetailsResponse: action.payload };

		case RoleActionTypes.DELETE_ROLE_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteRoleDetailsResponse: null };
		/** ***************** DELETE ROLE DETAILS END *********************** */

		default:
			return state;
	}
};
